module.exports = __webpack_public_path__ + "static/media/logo-font-white.e6676ab8.png";